// require("./bootstrap");

import { Datepicker } from "vanillajs-datepicker";
import moment from "moment";
import $ from "jquery";
import swal from "sweetalert2";
import axios from "axios";

// ===================================
// Common js logic
// ===================================
if (document.querySelector(".cancellation-policy")) {
    $(".cancellation-policy").on("click", function (event) {
        event.preventDefault();
        new swal({
            template: "#cancellation-policy-alert",
            confirmButtonColor: "#d7a939",
        });
    });
}
if (document.querySelector(".payment-policy")) {
    $(".payment-policy").on("click", function (event) {
        event.preventDefault();
        new swal({
            template: "#payment-policy-alert",
            confirmButtonColor: "#d7a939",
        });
    });
}
if (document.querySelector(".privacy-policy")) {
    $(".privacy-policy").on("click", function (event) {
        event.preventDefault();
        new swal({
            template: "#privacy-policy-alert",
            confirmButtonColor: "#d7a939",
        });
    });
}

// ===================================
// Step 1 js login
// ===================================
if (document.querySelector(".shop__step-1")) {
    // Documentation
    // https://mymth.github.io/vanillajs-datepicker/#/options

    var today = new Date();
    // var minDate = Date.parse(today.getFullYear() + "-03-01");
    // var maxDate = Date.parse(today.getFullYear() + "-12-31");
    var maxDate = Date.parse("2025-12-31");

    const book_time_elem = document.querySelector("#book_time");
    const book_date_elem = document.querySelector("#book_date");
    var today = new Date();
    if (book_date_elem.dataset.isAfterThree == 1) {
        // add a day
        today.setDate(today.getDate() + 1);
    }
    // console.log(book_date_elem.dataset.currentTime);
    const datepicker = new Datepicker(book_date_elem, {
        buttonClass: "btn",
        autohide: true,
        minDate: today,
        // minDate: today > minDate ? new Date() : minDate,
        maxDate: maxDate,
        format: "dd/mm/yyyy",
    });
    let calendarInput = document.querySelector(".calendar-input");
    calendarInput
        .querySelector(".calendar-icon")
        .addEventListener("click", function () {
            datepicker.show();
        });

    book_date_elem.addEventListener("changeDate", (event) => {
        get_times();
    });
    get_times();

    function get_times() {
        if (datepicker.getDate() === undefined) {
            return;
        }
        let date = moment(datepicker.getDate()).format("YYYY-MM-DD");
        book_time_elem.innerHTML = "";
        $.ajax({
            type: "GET",
            url: route("ajax.getTimes", [date]),
            success: function (data) {
                if (data.length) {
                    data.forEach((time) => {
                        var option = document.createElement("option");
                        option.text = time;
                        option.value = time;
                        book_time_elem.appendChild(option);
                    });
                } else {
                    var option = document.createElement("option");
                    option.text = 'No time slots found';
                    option.value = 'No time slots found';
                    option.disabled = true;
                    book_time_elem.appendChild(option);
                }
            },
            error: function (data, textStatus, errorThrown) {
                console.log(data);
            },
        });
    }
}


// ===================================
// Step 2 js login
// ===================================
if (document.querySelector(".shop__step-2")) {
    // Rows buttons logic
    let rows = document.querySelectorAll(".table-row");
    let rowButtons = document.querySelectorAll(".table-row__action .btn");
    if (rowButtons) {
        rowButtons.forEach((btn) => {
            btn.addEventListener("click", function (e) {
                e.preventDefault();
                // Close other rows and clear errors
                if (rows) {
                    rows.forEach((row) => {
                        row.querySelector("form").classList.remove("open");
                        let rowErrors =
                            row.querySelectorAll(".invalid-feedback");
                        if (rowErrors) {
                            rowErrors.forEach((error) => {
                                error.remove();
                            });
                        }
                    });
                }

                // Open this row
                let tableRow = btn.closest(".table-row");
                tableRow.querySelector("form").classList.add("open");
            });
        });
    }
    // Show row if has errors on page load
    if (rows) {
        rows.forEach((row) => {
            console.log(row.querySelector(".invalid-feedback"));
            if (row.querySelector(".invalid-feedback")) {
                row.querySelector("form").classList.add("open");
            }
        });
    }
}

// ===================================
// Step 3 js login
// ===================================
if (document.querySelector(".shop__step-3")) {
    let paymentMethods = document.querySelectorAll(".payment-method");
    paymentMethods.forEach((paymentMethod) => {
        let radio = paymentMethod.querySelector("input[type=radio]");
        radio.addEventListener("change", (event) => {
            clearAllCheckedRadios();
            if (event.currentTarget.checked) {
                radio.closest("label").classList.add("checked");
            } else {
                radio.closest("label").classList.remove("checked");
            }
        });
    });

    function clearAllCheckedRadios() {
        let radios = document.querySelectorAll("input[type=radio]");
        radios.forEach((radio) => {
            radio.closest("label").classList.remove("checked");
        });
    }

    let aplyCouponButton = document.querySelector(".apply_coupon");
    if (aplyCouponButton) {
        let couponInput = document.querySelector("#coupon_code");
        aplyCouponButton.addEventListener("click", (e) => {
            e.preventDefault();
            console.log(couponInput.value);
            if (couponInput.value !== "") {
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        ),
                    },
                });
                $.ajax({
                    type: "POST",
                    url: route("shop.applyCoupon"),
                    data: {
                        coupon_code: couponInput.value,
                    },
                    success: function (data) {
                        if (data.success) {
                            window.location.reload();
                        }
                    },
                    error: function (data, textStatus, errorThrown) {
                        console.log(data);
                    },
                });
            }
        });
    }
}

// ===================================
// Delete confirmation sweet alert
// ===================================
$(".delete-confirm").on("click", function (event) {
    var form = $(this).closest("form");
    event.preventDefault();
    new swal({
        title: "Are you sure?",
        text: "This record and it's details will be permanantly deleted!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d7a939",
        confirmButtonText: "Yes, delete it!",
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            form.trigger("submit");
        }
    });
});

// ===================================
// ADMIN Disable date
// ===================================

if (document.querySelector(".disable-date-page")) {
    // Documentation
    // https://mymth.github.io/vanillajs-datepicker/#/options

    // var today = new Date();
    // var minDate = Date.parse(today.getFullYear() + "-03-01");
    // var maxDate = Date.parse(today.getFullYear() + "-10-31");

    let calendarInput = document.querySelector(".calendar-input");
    const book_date_elem = calendarInput.querySelector("input");
    const datepicker = new Datepicker(book_date_elem, {
        buttonClass: "btn",
        autohide: true,
        // minDate: today > minDate ? new Date() : minDate,
        // maxDate: maxDate,
        format: "dd/mm/yyyy",
    });
    calendarInput
        .querySelector(".calendar-icon")
        .addEventListener("click", function () {
            datepicker.show();
        });

    book_date_elem.addEventListener("changeDate", (event) => {
        // console.log(datepicker.getDate('yyyy-mm-dd'))
        location.href = route(
            "admin.disableDate.index",
            datepicker.getDate("yyyy-mm-dd")
        );
        //
    });
}
